module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner_konintodoke-photo-79b19c276abd167d96a55a79ffb299a1.png";